import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { EXTERNAL_REDIRECT_BY_PATH } from "./app/external-redirect/external-redirect-urls";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

const path = window.location.pathname.replace(/^\//, "").split("/")[0] ?? "";
const redirectUrl = EXTERNAL_REDIRECT_BY_PATH[path];
if (redirectUrl) {
  window.location.replace(redirectUrl);
} else {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}
